<template lang="pug">
  div
    .text-md.font-semibold.neutral700--text How many stamps you would like to collect?
    v-row.mt-12(align="center" justify="center")
      v-btn.mr-10.rounded-lg(depressed :class="[isDecrementDisabled ? 'neutral300': 'neutral500']" :disabled="isDecrementDisabled" icon :height="buttonSize" :width="buttonSize" @click="handleDecrement")
        v-icon(color="white") mdi-minus
      v-card.rounded-lg.counter-border(outlined)
        .text-center.py-3.px-6
          .text-xxs.neutral500--text Stamps
          .text-xl {{ value }}
      v-btn.ml-10.rounded-lg(depressed :class="[isIncrementDisabled ? 'neutral300': 'neutral500']" icon :disabled="isIncrementDisabled" :height="buttonSize" :width="buttonSize" @click="handleIncrement")
        v-icon(color="white") mdi-plus
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1
    },
    valueCollected: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      buttonSize: '50px'
    };
  },
  computed: {
    isDecrementDisabled() {
      return this.value <= 1
    },
    isIncrementDisabled() {
      return this.value >= this.maxStampToCollect
    },
    maxStampToCollect() {
      return 10 - this.valueCollected
    }
  },
  methods: {
    handleIncrement() {
      this.$emit('input', this.value + 1)
    },
    handleDecrement() {
      if (this.value > 0) {
        this.$emit('input', this.value - 1)
      }
    },
  },
}
</script>

<style scoped>
.counter-border {
  border: 1px solid #C1C1C1;
}
</style>